<template>
    <div id="app">
      <!-- 刷新方法 -->
        <router-view/>
    </div>
</template>

<script>
export default {
    name: 'App',
    components: {
    },
    data () {
        return {
            isRouterAlive: true
        };
    },
    methods: {
        reload () {
            this.isRouterAlive = false;
            this.$nextTick(() => (this.isRouterAlive = true));
        }
    }
};
</script>
<style>
  html,body{
    width:100%;
    height: 100%;
  }
   /* @media screen and (max-device-width:960px){
      #app{
      width: calc(100% -2px)!important;
      margin-left: 1px;
      width: 100%;
      }
    } */
  #app{
    /* 设置整个内容区的最小宽度，以防止缩小内容区以后留白现象 */
    width: 100%;
    /* min-width: 1300px; */
    height: 100%;
    background: #f3f5f7;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue